import { cn } from '@blogging/utils'
import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

export function CopyButton({
  text,
  className,
}: {
  text: string
  className?: string
}) {
  const [copied, setCopied] = useState(false)
  return (
    <button
      onClick={() => {
        navigator.clipboard.writeText(text)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
      }}
      className={cn(
        'p-1 rounded hover:bg-muted text-muted-foreground hover:text-foreground transition-colors',
        className,
      )}
      aria-label="Copy"
    >
      {copied ? (
        <Check className="h-3.5 w-3.5" />
      ) : (
        <Copy className="h-3.5 w-3.5" />
      )}
    </button>
  )
}

export function CodeBlock({ code }: { code: string }) {
  return (
    <div className="relative">
      <pre className="bg-muted text-foreground rounded-lg py-3 pl-4 pr-10 text-xs font-mono overflow-x-auto leading-relaxed">
        <code className="bg-transparent p-0 text-foreground">{code}</code>
      </pre>
      <div className="absolute top-2 right-2">
        <CopyButton text={code} />
      </div>
    </div>
  )
}
